import React from "react";
import { SelectInput } from "react-admin";

const GameStatusSelect = () => {
  return (
    <SelectInput
      source="gameStatus"
      choices={[
        { id: "PRELIMINARY", name: "PRELIMINARY" },
        { id: "SCHEDULED", name: "SCHEDULED" },
        { id: "LIVE", name: "LIVE" },
        { id: "HALFTIME", name: "HALFTIME" },
        { id: "CANCELLED", name: "CANCELLED" },
        { id: "FORFEIT", name: "FORFEIT" },
        { id: "WEATHER_DELAY", name: "WEATHER_DELAY" },
        { id: "FINAL", name: "FINAL" }
      ]}
    />
  );
};

export default GameStatusSelect;
